import { ReactElement } from "react";
import cx from "classnames";

import { AdUnit, type AdUnitProps } from "./AdUnit";
import { useAdvertLoaded } from "./helpers";

export type AdvertisementProps = {
  rootClassName?: string;
  adUnitProps: AdUnitProps;
};

/**
 * This component renders an ad.
 * @param rootClassName - The root class name.
 * @param type - The type of the ad.
 * @param adUnitProps - The props for the ad.
 * @see https://www.imsph.sg/advertising-solutions/digital/imu/
 * @returns
 */
export default function Advertisement({
  rootClassName = "",
  adUnitProps,
}: AdvertisementProps): ReactElement {
  const advertLoaded = useAdvertLoaded(adUnitProps.type, adUnitProps.id);

  return (
    <div
      className={cx({ invisible: !advertLoaded }, rootClassName)}
      data-testid="advertisement-element"
    >
      <AdUnit {...adUnitProps} />
    </div>
  );
}
